var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubRx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E9F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8724 10.6447C12.407 9.87072 12.7201 8.93199 12.7201 7.92012C12.7201 5.26915 10.5711 3.12012 7.92012 3.12012C5.26915 3.12012 3.12012 5.26915 3.12012 7.92012C3.12012 8.93195 3.4332 9.87066 3.96776 10.6447C5.07693 9.83677 6.44282 9.36012 7.92005 9.36012C9.39732 9.36012 10.7633 9.8368 11.8724 10.6447ZM14.4382 9.56216C14.5701 9.03664 14.6402 8.48655 14.6402 7.92008C14.6402 6.44284 14.1636 5.07692 13.3556 3.96775C14.1296 3.43319 15.0683 3.12012 16.0802 3.12012C18.7311 3.12012 20.8802 5.26915 20.8802 7.92012C20.8802 8.93198 20.5671 9.87072 20.0325 10.6447C18.9233 9.8368 17.5574 9.36012 16.0801 9.36012C15.5137 9.36012 14.9636 9.4302 14.4382 9.56216ZM10.6447 12.1278C9.87068 11.5932 8.93196 11.2801 7.92012 11.2801C5.26915 11.2801 3.12012 13.4291 3.12012 16.0801C3.12012 18.7311 5.26915 20.8801 7.92012 20.8801C8.93196 20.8801 9.87067 20.567 10.6447 20.0325C9.83676 18.9233 9.36009 17.5574 9.36009 16.0801C9.36009 14.6029 9.83677 13.2369 10.6447 12.1278Z",
    fill: "#0086BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0803 20.8803C18.7312 20.8803 20.8803 18.7312 20.8803 16.0803C20.8803 13.4293 18.7312 11.2803 16.0803 11.2803C13.4293 11.2803 11.2803 13.4293 11.2803 16.0803C11.2803 18.7312 13.4293 20.8803 16.0803 20.8803Z",
    fill: "#85C7EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubRx);
export default __webpack_public_path__ + "static/media/hub-rx.a3444e9be84f66184e7c3172a783c2e7.svg";
export { ForwardRef as ReactComponent };